import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Box,
  TextField,
  FormGroup,
  Checkbox,
} from "@mui/material";
import { MyContext } from "../../Context/MyContext";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { RegisterFormContext } from "../../Context/RegisterFormContext";
import ButtonsGroup from "./ButtonsGroup";

export default function ScreenFour() {
  const {  isMobile } = useContext(MyContext);
  const { formData, setFormData, five, seven, eight, setAvailableScreens } =
    useContext(RegisterFormContext);

  const timePeriods = ["Before 12PM", "12PM - 3PM", "3PM - 6PM", "After 6PM"];
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const [lessonDates, setLessonDates] = useState([]);

  const handleSlotClick = (day, time) => {
    const slot = `${day}-${time}`;
    setLessonDates((prevSelectedSlots) =>
      prevSelectedSlots.includes(slot)
        ? prevSelectedSlots.filter((s) => s !== slot)
        : [...prevSelectedSlots, slot]
    );
  };

  const isSelected = (day, time) => lessonDates.includes(`${day}-${time}`);

  useEffect(() => {
    setFormData((prev) => ({ ...prev, lessonDates: lessonDates }));
  }, [lessonDates]);

  function handlePrev() {
    if (five.current) {
      five.current.scrollIntoView({ behavior: "smooth", block: "center" });

      
      setTimeout(() => {
        setFormData((prev) => ({
          ...prev,
          lessonDates: [],
        }))
          setAvailableScreens((prev) => ({ ...prev, screen6: false }));
        }, 500);
    }
  }

  function handleNext() {
    if(formData?.program === "IB DP"){
    setAvailableScreens((prev) => ({ ...prev, screen7: true }));
    setTimeout(() => {
      if (seven.current) {
        seven.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300);
  } else {
    setAvailableScreens((prev) => ({ ...prev, screen8: true }));
    setTimeout(() => {
      if (eight.current) {
        eight.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300);
  }
  }



  return (
    <div
      style={{
        marginBottom: "1rem",
        minHeight: "80vh",
        paddingTop: "5rem",
        paddingBottom: "5rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%" }}>
        <div style={{ marginTop: "2rem" }}>
          <Typography
            variant="h6"
            style={{ fontSize: "clamp(1.1rem, 4vw, 2rem" }}
          >
            How often would you like to take lessons?{" "}
            <span className="text-danger">*</span>
          </Typography>

          <form>
            <div>
              {/* TIME TABLE */}
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "space-between",
                  flex: 1,
                }}
              >
                <div
                  style={{
                    flex: 1,
                    gap: "10px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      minHeight: "40px",
                      padding: "5px",
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: isMobile ? "small" : "1rem",
                    }}
                  >
                    GMT
                  </div>
                  {timePeriods.map((time) => (
                    <div
                      key={time}
                      style={{
                        flex: 1,
                        minHeight: "40px",
                        padding: "5px",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        whiteSpace: isMobile ? "wrap" : "nowrap",
                        justifyContent: "center",
                        fontSize: isMobile ? "x-small" : "1rem",
                      }}
                    >
                      {time}
                    </div>
                  ))}
                </div>

                {days.map((day) => (
                  <div
                    key={day}
                    style={{
                      flex: 1,
                      gap: "10px",
                      display: "flex",
                      flexDirection: "column",
                      minWidth: isMobile ? "auto" : "50px",
                      fontSize: isMobile ? "small" : "1rem",
                      maxWidth: isMobile ? "10%" : "100%",
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        minHeight: "40px",
                        padding: "5px",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {day.slice(0, 3)}
                    </div>
                    {timePeriods.map((time) => (
                      <div
                        key={time}
                        style={{
                          flex: 1,
                          minHeight: "40px",
                          padding: "5px",
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          userSelect: "none",
                          transition: "all 0.5s ease-in-out",
                          cursor: "pointer",
                          background: isSelected(day, time)
                            ? "#007bff"
                            : "#ccc",
                        }}
                        onClick={() => handleSlotClick(day, time)}
                      ></div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </form>
        </div>

        <ButtonsGroup
          nextDisabled={formData.lessonDates?.length <= 0}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      </div>
    </div>
  );
}
